import React, { useState, useEffect } from 'react';
import { GelColumnLayout, GelRowLayout, GelContainerLite, GelBoxLayout} from '@tal-gel/components';
import { formatDateTime } from '../Shared/Text';
import { toastDiv, toastFail, defaultH3Text, boldLabel, subSectionMinHeight, subSectionTitle, tableHeaderText, tableBodyOddRow, tableBodyEvenRow, tableBodyDownloadLink } from '../Shared/Styles';
import PaginationButtons from '../../components/Shared/PaginationButtons';
import ToastMessage from '../../components/Shared/ToastMessage';
import GetAlterPolicy from '../../services/GetAlterPolicy';
import Spinner from '../../components/Spinner/Spinner';

const AlterPolicy = React.memo(({
    distributorClientNo,
    distributorNo,
    policyNumber
}) => {
    const [totalAlterPolicyCount, setTotalAlterPolicyCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [alterPolicyData, setAlterPolicyData] = useState([]);
    const [failToastMessage, setfailToastMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const togglefailToastMessage = () => setfailToastMessage(!failToastMessage);

    const query = "";
    const sortField = "title";
    const sort = "az";
    const facets = "ct_8207D398DF5F4463B56FA672EEC20198"; // ContentTagPrefix

    async function retrieveAlterPolicy() {

        try {
            setLoading(true)
            const result = await GetAlterPolicy(
                policyNumber,
                currentPage,
                query,
                pageSize,
                sortField,
                sort,
                facets
            );
    
            if (result !== undefined) {
                setTotalAlterPolicyCount(result.count);
                setAlterPolicyData(sortData(result.items));
            }
            else {
                throw Error(result.statusText);
            }
        } 
        catch (error) {
            setfailToastMessage(true);
        } 
        finally {
            setLoading(false);
        }
    }

    const sortData = (items) => {
        return items; // user sortField and sort in search query to sort data.
    };

    useEffect(() => {
        try {
            retrieveAlterPolicy();
        }
        catch (error) {
            return (<div>error</div>);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize]); // useEffect hook to currentPage state

    return (
        <GelContainerLite style={subSectionMinHeight}>
            <Spinner loading={loading} />
            <hr />
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="alterPolicyLabel">Policy alteration forms</h3>
            </GelRowLayout>
            <GelRowLayout gutter="medium" style={tableHeaderText}>
                <GelBoxLayout space={[2,5,1,2]}>
                    <div style={boldLabel}>Category</div>
                    <div style={boldLabel}>Document Name</div>
                    <div style={boldLabel}>Size</div>
                    <div style={boldLabel}>Published</div>
                </GelBoxLayout>
            </GelRowLayout>
            {(alterPolicyData.length === 0 && !loading) ?
                <GelRowLayout gutter="medium">
                    <GelColumnLayout style={tableBodyEvenRow}>
                        There are no alteration documents to be displayed
                    </GelColumnLayout>
                </GelRowLayout>
                : alterPolicyData.map((ap, index) =>
                    <div key={index}>
                        <GelRowLayout gutter="medium" style={(index % 2 === 0) ? tableBodyEvenRow : tableBodyOddRow}>
                            <GelBoxLayout space={[2,5,1,2]}>
                                <div data-testid="alterPolicyCategory">
                                    {ap.category}
                                </div>
                                <div data-testid="alterPolicyHeading">
                                    {ap.heading}
                                </div>
                                <div data-testid="alterPolicySize">
                                    {ap.size}
                                </div>
                                <div data-testid="alterPolicyDate">
                                    {formatDateTime(ap.date)}
                                    <a href={ap.url} title={ap.heading} target="_blank" rel="noreferrer" style={tableBodyDownloadLink}><i className="fa fa-download download-icon"></i> Download</a>
                                </div>
                            </GelBoxLayout>
                        </GelRowLayout>
                    </div>
                )}

            <PaginationButtons totalCount={totalAlterPolicyCount} pageSize={pageSize} setPageSize = {setPageSize} currentPage={currentPage} setCurrentPage={setCurrentPage}></PaginationButtons>

            <div style={toastDiv}>
                <ToastMessage
                    toggleToast={togglefailToastMessage}
                    toastType={toastFail}
                    showToast={failToastMessage}
                    message={'Failed to retrieve policy documents. Please try again.'} />
            </div>
        </GelContainerLite>
    );
});

export default AlterPolicy;